import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { ApiResponse } from '@interfaces/api/api.interface';
import { OrderInterface } from '@interfaces/orders/order-interface';
import { LanguageService } from '@core/services/language/language.service';

@Injectable({
  providedIn: 'root',
})
export class OrdersService {
  private http = inject(HttpClient);
  private ordersEndpoint = environment.endpoints.orders;
  private api = environment.API_URL;
  private locale = inject(LanguageService);

  public createOrder(order: OrderInterface, captchaToken = ''): Observable<ApiResponse<void>> {
    let httpParams = new HttpParams();
    httpParams = httpParams.set('locale', this.locale.getCurrentLanguage().toUpperCase());
    const headers = new HttpHeaders({ 'x-captcha-token': captchaToken });
    return this.http.post<ApiResponse<void>>(`${this.api}/${this.ordersEndpoint}`, order, {
      headers: headers,
      params: httpParams,
    });
  }
}
